/**
 * Alerts.js
 * Written by: Alex Kasemir
 */
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Transition, TransitionGroup } from 'react-transition-group';

import alertActions from '../../store/alert/actions';

import {
  AlertsContainer,
  QuizHiveAlert,
  WarnIcon,
  CloseButton,
  MessageContainer,
} from './Alerts.styles';

/**
 * Holds all the alerts that were made
 *
 * @param {} alerts - Description of alerts
 * @param {} removeAlert - Description of removeAlert
 */
export class Alerts extends Component {
  static propTypes = {
    alerts: PropTypes.object.isRequired,
    removeAlert: PropTypes.func.isRequired,
  }

  handleClick = (id) => {
    return () => {
      const { removeAlert } = this.props;
      removeAlert({ id });
    };
  }

  render() {
    const { allIds, byId } = this.props.alerts;

    const items = allIds.map((id) => {
      const { message, type } = byId[id];
      return (
        <Transition
          key={id}
          timeout={500}
        >
          {
            (state) => (
              <QuizHiveAlert
                state={state}
                type={ type }
              >
                <WarnIcon />
                <MessageContainer>
                  <p>{message}</p>
                </MessageContainer>
                <CloseButton onClick={ this.handleClick(id) } />
              </QuizHiveAlert>
            )
          }
        </Transition>
      );
    });

    return (
      <AlertsContainer>
        <TransitionGroup appear component={null}>
          {items}
        </TransitionGroup>
      </AlertsContainer>
    );
  }
}

export default connect((state) => {
  return {
    alerts: state.alert,
  };
}, {
  removeAlert: alertActions.destroyAlert,
})(Alerts);
